import { type Project } from '@consigli/types';
import { type FC } from 'react';

import { AGENT_MARKS } from '@/components/agent-marks';
import { type ServiceData } from '@/features/project-services/use-project-services';

import { AgentCard } from './agent-card';

interface AgentCardGridProps {
  services: ServiceData[];
  projectId: Project['id'];
}

/**
 * The Agents tab's grid.
 *
 * Its own rather than `layouts/card-grid.tsx`, which is viewport-breakpoint
 * based: the agent chat narrows this container without changing the viewport, so
 * that grid would keep its column count and squash the cards. 266 is measured
 * off the frame — 4 × 266 + 3 × 16 = 1112, its column exactly.
 *
 * `min(266px, 100%)` and not a bare 266px: minmax floors the track at its
 * minimum even as the only track, so a narrower container scrolls sideways
 * instead of reflowing. Phone width reaches that with the nav expanded.
 */
export const AgentCardGrid: FC<AgentCardGridProps> = ({ services, projectId }) => (
  <div className="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(min(266px,100%),1fr))]">
    {services.map((service) => (
      <AgentCard
        key={service.serviceName}
        mark={AGENT_MARKS[service.serviceName]}
        projectId={projectId}
        service={service}
      />
    ))}
  </div>
);
